import React, { useEffect, useState } from 'react';
import HiringSection from './HiringSection';
import { useHiringAssessmentDashboard } from 'src/hooks/hiringAssessment.hooks';

const CampusHiringSection = () => {
	const { data: hiringAssessmentDashboardData, isLoading: hiringAssessmentDashboardDataLoading } =
		useHiringAssessmentDashboard();

	const [campusArray, setCampusArray] = useState<
		{
			id: number;
			process: string;
			count: number;
			positionData?: { assessmentPending: number; interviewing: number; rejected: number };
			badge?: string;
		}[]
	>([
		{ id: 1, process: 'Shortlisted', count: 0 },
		{
			id: 2,
			process: 'Interviews',
			count: 0,
			positionData: { assessmentPending: 0, interviewing: 0, rejected: 0 },
			badge: '',
		},
		{
			id: 3,
			process: 'Invited',
			count: 0,
		},
		{
			id: 4,
			process: 'Registered in placement drive',
			count: 0,
			positionData: { assessmentPending: 0, interviewing: 0, rejected: 0 },
		},
	]);

	useEffect(() => {
		if (hiringAssessmentDashboardData?.result) {
			setCampusArray([
				{ ...campusArray[0], count: hiringAssessmentDashboardData?.result?.campusHiringShortlistedCount },
				{
					...campusArray[1],
					count: hiringAssessmentDashboardData?.result?.campusHiringInterviewScheduledCount,
					badge: `${hiringAssessmentDashboardData?.result?.campusHiringUpcomingInterviewScheduledCount} new`,
				},
				{ ...campusArray[2], count: hiringAssessmentDashboardData?.result?.campusHiringDriveInvitationsCount },
				{ ...campusArray[3], count: hiringAssessmentDashboardData?.result?.campusHiringDriveRegistered },
			]);
		}
	}, [hiringAssessmentDashboardData]);
	return (
		<HiringSection
			heading="Placement Drive"
			subheading="Hire final-year students for 2025."
			positions={campusArray}
			linkUrl="/campus-candidates"
			linkText="View details →"
			logoSrc="/assets/recruiterDashboard/campushiring.svg"
		/>
	);
};

export default CampusHiringSection;
